import { Typography } from "@mui/material";
import { translate } from "../../../translate/translate";
import AiDemandForecastPanel from "./ai-demand-forecast-panel.component";

const AiDemandForecastPageComponent = () => (
  <section>
    <div className="floating-title" style={{ display: "flex", alignItems: "center" }}>
      <Typography variant="h5">{translate.t("ai_demand_forecast")}</Typography>
    </div>
    <AiDemandForecastPanel allowModelFilter />
  </section>
);

export default AiDemandForecastPageComponent;
